import requestv2 from "~/utils/http-v2";

const dashboardApi = {
	saleCommit : async (params) => {
		const url = 'v2/dashboard/sale/commit';
		return await requestv2.get(url, {params});
	},
	salePoint : async (params) => {
		const url = 'v2/dashboard/sale/point';
		return await requestv2.get(url, {params});
	},
	saleKpi : async (params) => {
		const url = 'v2/dashboard/sale/kpi';
		return await requestv2.get(url, {params});
	},
	saleNoConsultation : async (params) => {
		const url = 'v2/dashboard/sale/no-consultation';
		return await requestv2.get(url, {params});
	},
	saleLowestPerformers : async (params) => {
		const url = 'v2/dashboard/sale/lowest-performers';
		return await requestv2.get(url, {params});
	},
	revenue : async (params) => {
		const url = 'v2/dashboard/revenue';
		return await requestv2.get(url, {params});
	},
	revenueRanks : async (params) => {
		const url = 'v2/dashboard/revenue/ranks';
		return await requestv2.get(url, {params});
	},
	revenueGroup : async (params) => {
		const url = 'v2/dashboard/revenue/group';
		return await requestv2.get(url, {params});
	},
	contractNew : async (params) => {
		const url = 'v2/dashboard/contract/new';
		return await requestv2.get(url, {params});
	},
	customer : async (params) => {
		const url = 'v2/dashboard/customer';
		return await requestv2.get(url, {params});
	},
	customerGroup : async (params) => {
		const url = 'v2/dashboard/customer/group';
		return await requestv2.get(url, {params});
	},
	designProject : async (params) => {
		const url = 'v2/dashboard/design/project';
		return await requestv2.get(url, {params});
	},
	designRanks : async (params) => {
		const url = 'v2/dashboard/design/ranks';
		return await requestv2.get(url, {params});
	},
	personnelCount : async (params) => {
		const url = 'v2/dashboard/personnel/count';
		return await requestv2.get(url, {params});
	},
	personnelBirthday : async (params) => {
		const url = 'v2/dashboard/personnel/birthday';
		return await requestv2.get(url, {params});
	},
	personnelProbationExpiring : async (params) => {
		const url = 'v2/dashboard/personnel/probation-expiring';
		return await requestv2.get(url, {params});
	},
	personnelContractExpiring : async (params) => {
		const url = 'v2/dashboard/personnel/contract-expiring';
		return await requestv2.get(url, {params});
	},
	//Dashboard CEO - toàn công ty, nhận params kỳ {period, time, ...}
	ceoOverview : async (params) => {
		const url = 'v2/dashboard/ceo/overview';
		return await requestv2.get(url, {params});
	},
	ceoRevenueTrend : async (params) => {
		const url = 'v2/dashboard/ceo/revenue-trend';
		return await requestv2.get(url, {params});
	},
	ceoRevenueByGroup : async (params) => {
		const url = 'v2/dashboard/ceo/revenue-by-group';
		return await requestv2.get(url, {params});
	},
	ceoTopPerformers : async (params) => {
		const url = 'v2/dashboard/ceo/top-performers';
		return await requestv2.get(url, {params});
	},
	ceoFinance : async (params) => {
		const url = 'v2/dashboard/ceo/finance';
		return await requestv2.get(url, {params});
	},
	ceoEvaluationFailed : async (params) => {
		const url = 'v2/dashboard/ceo/evaluation-failed';
		return await requestv2.get(url, {params});
	},
	//Dashboard Kế toán trưởng - dữ liệu tài chính theo tháng {time}
	accountingPnl : async (params) => {
		const url = 'v2/dashboard/accounting/pnl';
		return await requestv2.get(url, {params});
	},
	accountingCashFlow : async (params) => {
		const url = 'v2/dashboard/accounting/cash-flow';
		return await requestv2.get(url, {params});
	},
	accountingSalary : async (params) => {
		const url = 'v2/dashboard/accounting/salary';
		return await requestv2.get(url, {params});
	},
	accountingPendingReceipt : async (params) => {
		const url = 'v2/dashboard/accounting/pending-receipt';
		return await requestv2.get(url, {params});
	},
	accountingContractRanks : async (params) => {
		const url = 'v2/dashboard/accounting/contract-ranks';
		return await requestv2.get(url, {params});
	},
};

export default dashboardApi;